import TailInIcon from "../../../../../components/icons/TailInIcon";
import TailOutIcon from "../../../../../components/icons/TailOutIcon";
import Avatar from "../../../../../components/generic/Avatar";
import dayjs from "../../../../../utils/dayjs";
import { getFullName } from "../../../../../utils/shared";
import { useCallback, useMemo, useState } from "react";
import RewriteMessage from "../ChatInput/RewriteMessage";
import { renderContentWithLinks } from "./LinkUtils";
import { JOIN_MEETING_TOKEN } from "../../../../../constant";
import JoinMeeting from "./JoinMetting";
import Translate from "../../../../../components/icons/Translate";
import FileAttachment from "./FileAttachment";
import Reactions from "../../../../../components/shared/Reactions";
import { nanoid } from "@reduxjs/toolkit";
import {
  sendWebSocketMessage,
  setKeyValue,
} from "../../../../../store/chats/slice";
import { useDispatch } from "react-redux";
import ReactionsList from "../../../../../components/shared/Reactions/ReactionsList";
import ContactMessage from "./ContactMessage";

const MessageItem = ({
  message,
  isCurrentUser,
  users,
  loggedUser,
  selectedTenantId,
}) => {
  const { message_attachment: attachment } = message;
  const [showModal, setShowModal] = useState(false);
  const [content, setContent] = useState(message.content);

  const dispatch = useDispatch();
  const { isImage, isAudio } = useMemo(() => {
    const isImage = attachment?.mime_type?.startsWith("image");
    const isAudio = attachment?.mime_type?.startsWith("audio");

    return { isImage, isAudio };
  }, [attachment]);

  const isSystem = message?.sender_type === "system";

  const onClickReaction = useCallback(
    (emoji) => {
      const payload = {
        action: "updateReaction",
        data: {
          message_id: message?.id,
          sender_id: loggedUser?.user_id,
          emoji,
          sender_type: "user",
          clientMessageId: nanoid(),
        },
        conversation_id: message?.conversation_id,
        tenant_id: selectedTenantId,
      };
      //@ts-ignore
      dispatch(sendWebSocketMessage(payload));
    },
    [message, loggedUser, selectedTenantId, dispatch],
  );

  return (
    <div
      key={message.id}
      className={`message-wrapper ${isCurrentUser ? "own-message" : ""} ${isSystem ? "system-message" : ""}`}
    >
      {!isCurrentUser && (
        <Avatar size={32} className="message-avatar" user={message?.sender} />
      )}
      {!isCurrentUser && !isSystem && <TailInIcon />}
      <div className="message-bubble">
        {!isCurrentUser && (
          <div
            className={`message-sender ${attachment?.filename ? "sender-with-file" : ""}`}
          >
            {getFullName(message.sender)}
          </div>
        )}

        {attachment?.filename && (
          <FileAttachment attachment={attachment} message={message} />
        )}

        {message.message_type === "contact" ? (
          <ContactMessage contacts={message.metadata} />
        ) : (
          <>
            {message.content && (
              <div
                className={`message-content ${isImage || isAudio ? "message-image-content" : ""}`}
              >
                {content?.endsWith(JOIN_MEETING_TOKEN) ? (
                  <JoinMeeting message={content} />
                ) : (
                  renderContentWithLinks({ text: content, users })
                )}
              </div>
            )}
          </>
        )}

        <div className="flex align-center message-time">
          {content && (
            <div
              className="translate-message-div cursor-pointer"
              onClick={() => setShowModal(true)}
            >
              <Translate size={14} />
            </div>
          )}
          {message?.clientMessageId
            ? "sending..."
            : dayjs(message.sent_at).format("DD MMM, hh:mm A")}
        </div>
        {content && (
          <Reactions
            reactions={message?.reactions}
            loggedUser={loggedUser}
            onClickReaction={onClickReaction}
          />
        )}
        {!!message?.reactions?.length && (
          <ReactionsList
            reactions={message?.reactions}
            onClick={() => {
              dispatch(
                setKeyValue({
                  key: "reactions",
                  value: message?.reactions,
                }),
              );
            }}
          />
        )}
      </div>
      {isCurrentUser && <TailOutIcon />}

      {showModal && (
        <RewriteMessage
          setMessage={(value) => {
            setContent(value);
            setShowModal(false);
          }}
          originalMessage={content}
          onClose={() => setShowModal(false)}
          isForMessage
        />
      )}
    </div>
  );
};

export default MessageItem;
